// src/api/inventory/productMergeApi.ts
import { ENV } from '../../config/runtimeEnv';
import type { Product, ProductMergeRequest, ProductMergeRequestListParams, ProductMergeRequestApproveParams, ProductMergeRequestRejectParams, BulkApproveParams, MergeRequestStatistics } from '../../types/inventory/ProductTypes';
import { http } from "../../lib/http/client";
const API_BASE_URL = ENV.VITE_COMMERCE_SERVER;


export const fetchProductMergeRequests = async (params: ProductMergeRequestListParams): Promise<{ success: boolean; data: any; message: string }> => {
	const response = await http.get(`${API_BASE_URL}/shopify/merge-requests`, {
		params,
	});
	return response.data;
};

export const fetchProductMergeRequest = async (id: number): Promise<{ success: boolean; data: ProductMergeRequest; message: string }> => {
	const response = await http.get(`${API_BASE_URL}/shopify/merge-requests/${id}`);
	return response.data;
};

export const approveProductMergeRequest = async (id: number, params: ProductMergeRequestApproveParams): Promise<{ success: boolean; data: { merge_request: ProductMergeRequest; merged_product: Product }; message: string }> => {
	const response = await http.post(`${API_BASE_URL}/shopify/merge-requests/${id}/approve`, params);
	return response.data;
};

export const rejectProductMergeRequest = async (id: number, params: ProductMergeRequestRejectParams): Promise<{ success: boolean; data: ProductMergeRequest; message: string }> => {
	const response = await http.post(`${API_BASE_URL}/shopify/merge-requests/${id}/reject`, params);
	return response.data;
};

export const bulkApproveProductMergeRequests = async (params: BulkApproveParams): Promise<{ success: boolean; data: { success: any[]; failed: any[] }; message: string }> => {
	const response = await http.post(`${API_BASE_URL}/shopify/merge-requests/bulk-approve`, params);
	return response.data;
};

export const fetchMergeRequestStatistics = async (): Promise<{ success: boolean; data: MergeRequestStatistics; message: string }> => {
	const response = await http.get(`${API_BASE_URL}/shopify/merge-requests/statistics`);
	return response.data;
};